export const APP_VIEWPORT_HEIGHT_VAR = '--app-viewport-height';
export const APP_VIEWPORT_HEIGHT = `var(${APP_VIEWPORT_HEIGHT_VAR}, 100vh)`;

export const viewportHeightWithOffset = (offsetPx: number) =>
  `calc(${APP_VIEWPORT_HEIGHT} - ${offsetPx}px)`;

export const resetBootstrapBodyStyles = () => {
  const { style } = document.body;

  style.backgroundColor = '';
  style.overflow = '';
  style.transition = '';
  style.transitionDelay = '';
  style.filter = '';
};

// The application shell must use the layout viewport. On iOS the visual
// viewport can temporarily shrink to the area above the URL editor keyboard,
// which would leave the full-height bootstrap body visible below the app.
const getViewportHeight = () => window.innerHeight;

export const updateViewportHeightVar = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return;

  const viewportHeight = getViewportHeight();

  if (viewportHeight > 0) {
    document.documentElement.style.setProperty(
      APP_VIEWPORT_HEIGHT_VAR,
      `${viewportHeight}px`
    );
  }
};

export const initializeViewportHeightVar = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return () => {};
  }

  updateViewportHeightVar();

  const viewportEvents = ['resize', 'orientationchange', 'pageshow', 'focus'];
  const { visualViewport } = window;

  viewportEvents.forEach((eventName) => {
    window.addEventListener(eventName, updateViewportHeightVar);
  });
  if (visualViewport) {
    visualViewport.addEventListener('resize', updateViewportHeightVar);
  }

  return () => {
    viewportEvents.forEach((eventName) => {
      window.removeEventListener(eventName, updateViewportHeightVar);
    });
    if (visualViewport) {
      visualViewport.removeEventListener('resize', updateViewportHeightVar);
    }
  };
};
